import { render, staticRenderFns } from "./entrustChildVideo.vue?vue&type=template&id=5067a132&scoped=true&"
import script from "./entrustChildVideo.vue?vue&type=script&lang=js&"
export * from "./entrustChildVideo.vue?vue&type=script&lang=js&"
import style0 from "./entrustChildVideo.vue?vue&type=style&index=0&id=5067a132&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067a132",
  null
  
)

export default component.exports